import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService, SEOService } from '@box-core/services';
import { ConfirmDialogResponse, MarketCard, SeoOptions } from '@box-types';
import { deleteJsonLd } from '@box/utils';
import { finalize, Subscription } from 'rxjs';
import { AccountMarketCardsService } from './account-market-cards.service';

@Component({
  selector: 'account-market-cards',
  templateUrl: './account-market-cards.page.html',
  styleUrls: ['./account-market-cards.page.scss'],
  providers: [AccountMarketCardsService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountMarketCardsPage implements OnInit, OnDestroy {
  public marketCards: MarketCard[];
  public hasCards: boolean;

  private cardsSubscription: Subscription;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private accountMarketCardsService: AccountMarketCardsService,
    private loaderService: LoaderService,
    private activatedRoute: ActivatedRoute,
    private seoService: SEOService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // This can be replaced in the future with an endpoint
    this.accountMarketCardsService.setCards(this.accountMarketCardsService.getUserCards());
    this.accountMarketCardsService.cards$.subscribe((marketCards) => {
      this.marketCards = marketCards;
      this.hasCards = marketCards.length > 0;
    });
    this.setMetaTags();
  }

  ngOnDestroy(): void {
    this.cardsSubscription?.unsubscribe();
    deleteJsonLd();
  }

  public onMarketCardDelete(marketCard: MarketCard): void {
    this.accountMarketCardsService
      .openDisconnectCardDialog(marketCard)
      .afterClosed()
      .subscribe((data: ConfirmDialogResponse) => {
        if (!data?.accepted) return undefined;
        this.loaderService.setState(true);
        this.accountMarketCardsService
          .disconnectCard(marketCard)
          .pipe(
            finalize(() => {
              this.loaderService.setState(false);
              this.changeDetectorRef.detectChanges();
            })
          )
          .subscribe(() => {
            this.accountMarketCardsService.removeCard(marketCard);
            this.accountMarketCardsService.removeCardFromUser(marketCard);
          });
      });
  }

  private setMetaTags(): void {
    const options: SeoOptions = { title: this.activatedRoute.snapshot.data.breadcrumbName, url: this.router.url };
    this.seoService.setTags(options);
  }
}
